// extracted by mini-css-extract-plugin
export default {"container":"forgot-password_container__jPaHR","form":"forgot-password_form__Ux8cC","errorContainer":"forgot-password_errorContainer__-RctK"};